import React from 'react';
import SignUpCard from '../components/SignupCard';

const SignUp = () => {
  return (
    <div className='auth-container'>
        <img src="./Images/banner.png" alt="banner" />
        <SignUpCard />
    </div>
  )
}

export default SignUp